import { render, staticRenderFns } from "./ViewProdInfo.vue?vue&type=template&id=94ec57b2&scoped=true"
import script from "./ViewProdInfo.vue?vue&type=script&lang=js"
export * from "./ViewProdInfo.vue?vue&type=script&lang=js"
import style0 from "./ViewProdInfo.vue?vue&type=style&index=0&id=94ec57b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ec57b2",
  null
  
)

export default component.exports